import { cn } from "@/lib/util";
import { Flame, ShieldAlert, ShieldCheck, Shield } from "lucide-react";

const LABELS = {
  critical: { text: "Prioridad crítica", cls: "border-sev-critical/60 text-sev-critical bg-sev-critical/10", Icon: Flame },
  high:     { text: "Prioridad alta",    cls: "border-sev-high/60 text-sev-high bg-sev-high/10",         Icon: ShieldAlert },
  medium:   { text: "Prioridad media",   cls: "border-sev-medium/60 text-sev-medium bg-sev-medium/10",   Icon: Shield },
  low:      { text: "Prioridad baja",    cls: "border-sev-low/60 text-sev-low bg-sev-low/10",            Icon: ShieldCheck },
};

/**
 * Renders the remediation Priority Score (0-10) with a color-coded label.
 * The score comes from the backend `compute_priority()` helper — do NOT
 * recompute in the UI to avoid divergence.
 */
export function PriorityBadge({ score, label, compact = false, className }) {
  const meta = LABELS[label] || LABELS.low;
  const val = typeof score === "number" ? score.toFixed(1) : "—";
  return (
    <span
      data-testid={`priority-badge-${label || "unknown"}`}
      title={meta.text}
      className={cn(
        "inline-flex items-center gap-1 border font-mono uppercase tracking-widest",
        compact ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-1 text-[10px]",
        meta.cls,
        className
      )}
    >
      <meta.Icon className={compact ? "w-2.5 h-2.5" : "w-3 h-3"} />
      <span className="tabular-nums">{val}</span>
      {!compact && <span>· {meta.text.replace("Prioridad ", "")}</span>}
    </span>
  );
}

export function priorityCellClass(label) {
  return LABELS[label]?.cls || LABELS.low.cls;
}
